import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { PlayerSize } from '@engineering11/multimedia-web'
import { UserMode } from '../../../model/component-modes.enum'
import { IPortfolio } from '../../../model/portfolio.model'
import { PortfolioStore } from '../portfolio.store.component'
import { FilesService } from '@engineering11/files-web'

@Component({
  selector: 'portfolio-video-line-item',
  template: `
    <div class="e11-p-0">
      <e11-confirmation
        #confirmation
        confirmTitle="{{ 'Delete this video' | translate }}"
        confirmText="{{ 'confirm' | translate }}"
        [closeOnEscape]="false"
        cancelText="{{ 'cancel' | translate }}"
        [backdropStyle]="'dark'"
        (answer)="confirmationAnswer($event)"
      >
        {{ 'Are you sure you want to remove this video? You can always add it back if you need to.' | translate }}
      </e11-confirmation>

      <div [ngClass]="{ 'e11-skeleton': !video }" class="e11-w-full">
        <video-player
          [playerSize]="PlayerSize.Small"
          [videoPlayerResource]="{ video: video?.file?.signedURL!, fallbackVideoUrl: fallbackUrl }"
          [videoPlayerConfig]="{ roundPlayerBorder: false }"
        ></video-player>
      </div>
      <div class="e11-border e11-border-skin-app-borders e11-p-2">
        <div class="e11-flex e11-items-center e11-justify-between">
          <div class="e11-max-w-[70%] e11-grow">
            <p class="e11-mb-0 e11-skeleton-empty e11-truncate">{{ video ? video?.file?.fileName : '' }}</p>
          </div>
          <e11-button
            *ngIf="userMode === UserMode.Candidate"
            [size]="'sm'"
            [buttonGroup]="false"
            [color]="'secondary'"
            [skeletonLoading]="!video"
            (click)="confirmation.open()"
            value="{{ 'Delete' | translate }}"
          ></e11-button>
        </div>
      </div>
    </div>
    <ui-portfolio-reference-name
      [item]="video"
      placeholder="No video name"
      [userMode]="userMode"
      (updateReferenceName)="onUpdateReferenceName($event)"
    ></ui-portfolio-reference-name>
  `,
})
export class PortfolioVideoLineItemComponent implements OnInit {
  @Input() video?: IPortfolio
  @Input() userMode = UserMode.Candidate
  @Output() deleteVideo = new EventEmitter()
  fallbackUrl?: string

  UserMode = UserMode

  PlayerSize = PlayerSize
  constructor(private portfolioStore: PortfolioStore, private filesService: FilesService) {}

  async ngOnInit() {
    if (this.video) this.fallbackUrl = await this.filesService.getVideoFallbackURL(this.video.file!)
  }

  confirmationAnswer(res: boolean) {
    if (res) this.deleteVideo.emit()
  }
  onUpdateReferenceName(referenceName: string) {
    const updateFile: IPortfolio = {
      ...this.video!,
      referenceName,
    }
    this.portfolioStore.onPortfolioItemUpdated(updateFile)
  }
}
